require("../../assets/javascripts/JCart.js")
require("../../assets/javascripts/payments.js")
require("../../assets/javascripts/PLM.js")